import React from "react";
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Box,
} from "@chakra-ui/react";
import { FaRegQuestionCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const P = "features.InvestmentScreening.Popover.updateImprovement";
const C = "common.label";

/**
 * 更新による改善効果の項目説明ポップオーバー
 *
 * 使用例:
 * <UpdateImprovementExplanationPopover />
 */
export const UpdateImprovementExplanationPopover: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Popover placement="right">
      <PopoverTrigger>
        <button style={{ background: 'none', border: 'none', padding: 0 }}>
          <FaRegQuestionCircle size="30px" cursor="pointer" />
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent width="800px" maxH="600px" overflowY="auto" bgColor="#fffff0">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader fontWeight="bold">{t(`${P}.title`)}</PopoverHeader>
          <PopoverBody>
            <Box mb={4}>
              <Table size="sm" variant="simple">
                <Thead>
                  <Tr>
                    <Th w="230px">{t(`${C}.columnName`)}</Th>
                    <Th>{t(`${C}.description`)}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td fontWeight="bold">{t(`${P}.recentAvgName`)}</Td>
                    <Td>{t(`${P}.recentAvgDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">{t(`${P}.launchPlanName`)}</Td>
                    <Td>{t(`${P}.launchPlanDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">{t(`${P}.updatePlanName`)}</Td>
                    <Td>{t(`${P}.updatePlanDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">{t(`${P}.actualVsPlanName`)}</Td>
                    <Td>{t(`${P}.actualVsPlanDesc`)}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>

            <Box>
              <Table size="sm" variant="simple">
                <Thead>
                  <Tr>
                    <Th w="60px">{t(`${C}.no`)}</Th>
                    <Th w="100px">{t(`${C}.item`)}</Th>
                    <Th>{t(`${C}.description`)}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>1</Td>
                    <Td fontWeight="bold">{t(`${P}.yieldName`)}</Td>
                    <Td>{t(`${P}.yieldDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>2</Td>
                    <Td fontWeight="bold">{t(`${P}.scrapCostName`)}</Td>
                    <Td>{t(`${P}.scrapCostDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>3</Td>
                    <Td fontWeight="bold">{t(`${P}.repairCostName`)}</Td>
                    <Td>{t(`${P}.repairCostDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>4</Td>
                    <Td fontWeight="bold">{t(`${P}.consumablesCostName`)}</Td>
                    <Td>{t(`${P}.consumablesCostDesc`)}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
